
export const ImageConverter = (images,type)=>{
   if(type === 'sold'){
       const NewUpdatedArray = images.map((image) => `https://s3.us-west-1.wasabisys.com/redbuyers-main/${image.url}`)
       return NewUpdatedArray
   }else{
     return images
   }
}